import ChatingTicket from "../View/Ticketing/Chating";
import CreateNewItem from "../View/NewItemrequest/Create";
import CreateTicket from "../View/Ticketing/Create";
import ListNewItem from "../View/NewItemrequest/List";
import ListReserves from "../View/OrderList/List";
import ListTicket from "../View/Ticketing/List";
import RouteDashboard from "../View/Dashboard/RouteDashboard";
import Wallet from "../View/Wallet";
import Settings from "../View/ProfileSetting/Edite";
import ReportUserCreate from "../View/Report/Pages/Create";
import ReportUserList from "../View/Report/Pages/List";
import ReportUserSingle from "../View/Report/Pages/Single";
import WaitComment from "../View/Comments/Wait";
import ListComments from "../View/Comments/List";
import ClassList from "../View/ClassList/Pages";
import ClassCreate from "../View/ClassCreate/Pages/CreateClass";
import SingleClass from "../View/ClassList/Pages/SingleClass";
import TagSeo from "../View/ClassList/Components/EditClassItems/TagSeoEdit";
import TeachersEdit from "../View/ClassList/Components/EditClassItems/TeachersEdit";
import TimeEdit from "../View/ClassList/Components/EditClassItems/TimeEdit";
import AddTeacher from "../View/ClassList/Components/EditClassItems/AddTeacher";
import AthletesListOfClass from "../View/ClassList/Pages/AthletesListOfClass";
import ManageTimeTable from "../View/EditItem/index";
import CommentManagementManager from "../View/CommentManagment/List";
import ManagerListReserves from "../View/ManageOrder/index";
import ActiveAthlethList from "../View/Athlethes/Pages/ActiveList";
import DeativeAthletesList from "../View/Athlethes/Pages/DeactiveList";
import AllAtheletesList from "../View/Athlethes/Pages/All";
import RequsetWalletCreate from "../View/RequestWallet/Create";
import RequsetWalletList from "../View/RequestWallet/List";
import ManFinantialDetails from "../View/FinantialDetails/Edite";
import EditItemDetails from "../View/EditItem/EditDetails";
import ContractItem from "../View/EditItem/Contract";
import OrderDetails from "../../Common/Components/OrderDetails";
import PAList from "../View/Athlethes/Pages/PAList";
import TimeReservesList from "../../Common/Components/TimeReservesList/Page";
import RenewalTermContract from "../View/RenewalTermContract/index";
import SelectItem from "../View/SelectItem/Pages";
import GeneralOrders from "../View/ManageOrder/GeneralOrders";
export let RoutesUser = [
  {
    path: "/User/Dashboard",
    sub: "",
    component: RouteDashboard,
    name: "UserDashboard",
    label: "داشبورد",
    icon: "icon ti-dashboard",
    type: ["default"],
  },
  {
    subscribe: true,
    name: "EditItem",
    label: "مدیریت مجموعه",
    icon: "icon ti-write",
    type: ["manager"],
    path: "",
  },
  {
    path: "/User/Details",
    sub: "EditItem",
    component: EditItemDetails,
    name: " DetailsEdit",
    label: "ویرایش جزییات",
    type: ["manager"],
    icon: "",
  },
  {
    path: "/User/Contract",
    sub: "EditItem",
    component: ContractItem,
    name: " Contract",
    label: "رزرو قراردادی",
    type: ["manager"],
    time: "needdate",
    model: "table",
    icon: "",
  },
  {
    label: "برداشت درآمد",
    subscribe: true,
    exact: true,
    icon: "icon ti-layers",
    type: ["manager", "classmanager"],
    name: "RequestWallet",
    path: "",
  },
  {
    label: "صورت حساب",
    subscribe: true,
    exact: true,
    icon: "icon ti-layers",
    type: ["manager", "classmanager"],
    name: "Bill",
    path: "",
  },
  {
    path: "/User/Wallet",
    sub: "",
    component: Wallet,
    name: "Wallet",
    label: "کیف پول",
    type: ["default"],
    icon: "icon ti-wallet",
  },
  {
    subscribe: true,
    name: "athlate",
    label: "مدیریت ورزشکاران",
    type: ["manager"],
    icon: "icon ti-write",
    path: "",
    time: "needsession",
    needdate: true,
  },
  {
    path: "/User/Athletes",
    sub: "",
    component: AllAtheletesList,
    name: "AllAtheletes",
    label: "مدیریت ورزشکاران",
    type: ["manager"],
    icon: "icon ti-write",
    time: "needdate",
  },

  {
    path: "/User/ActiveAthletes",
    sub: "athlate",
    component: ActiveAthlethList,
    name: "ActiveAthlth",
    label: "ورزشکاران فعال",
    type: ["manager"],
    time: "needsession",
    needdate: true,
    icon: "icon ti-clipboard",
  },
  {
    path: "/User/DeactiveAthletes",
    sub: "athlate",
    component: DeativeAthletesList,
    name: "َAllAthlth",
    needdate: true,
    label: "ورزشکاران غیر فعال",

    type: ["manager"],
    time: "needsession",
    icon: "icon ti-clipboard",
  },
  {
    path: "/User/Reserves",
    sub: "",
    component: ListReserves,
    name: "Reserves",
    label: "لیست سفارشات",
    icon: "icon ti-control-shuffle",
    type: ["default"],
  },
  {
    subscribe: true,
    name: "Comments",
    label: "نقد و نظرات",
    icon: "icon ti-comment",
    type: ["default"],
    path: "",
  },
  {
    path: "/User/WaitComments",
    name: "WaitComments",
    exact: true,
    component: WaitComment,
    label: "در انتظار نظر",
    sub: "Comments",
    type: ["default"],
    icon: null,
  },
  {
    path: "/User/Comments",
    name: "Comments",
    exact: true,
    component: ListComments,
    label: "نظرات من",
    sub: "Comments",
    type: ["default"],
    icon: null,
  },
  {
    subscribe: true,
    name: "Ticketing",
    label: "پشتیبانی",
    path: "",
    icon: "icon ti-folder",
    type: ["default"],
  },
  {
    subscribe: true,
    name: "Report",
    path: "",
    label: "گزارش اشکال",
    icon: "icon ti-alert",
    type: ["default"],
  },
  {
    path: "/User/Report/Create",
    name: "ReportCreate",
    exact: true,
    component: ReportUserCreate,
    label: "ثبت اشکال",
    sub: "Report",
    icon: null,
    type: ["default"],
  },
  {
    path: "/User/Report/list",
    name: "ReportUserList",
    exact: true,
    component: ReportUserList,
    label: "لیست اشکالات",
    icon: null,
    sub: "Report",
    type: ["default"],
  },
  {
    path: "/User/Report/Single",
    component: ReportUserSingle,
    type: ["default"],
  },
  {
    path: "/User/ticketing/Create",
    exact: true,
    component: CreateTicket,
    name: "CreateTicket",
    sub: "Ticketing",
    label: "ثبت درخواست",
    type: ["default"],
  },
  {
    path: "/User/ticketing/List",
    exact: true,
    component: ListTicket,
    name: "ListTicket",
    sub: "Ticketing",
    label: "لیست درخواست های شما",
    type: ["default"],
  },
  {
    path: "/User/ticketing/List/:id",
    name: "ListTicket",
    exact: true,
    component: ChatingTicket,
    label: "ارتباط با پشتیبانی",
    icon: null,
    type: ["default"],
  },
  {
    path: "/User/FinancialDetails/Form",
    name: "FinancialDetails",
    exact: true,
    component: ChatingTicket,
    label: "اطلاعات مالی",
    icon: null,
    type: ["default"],
  },
  {
    path: "#NewItemRequest",
    subscribe: true,
    name: "Request",
    label: "درخواست ثبت مجموعه",
    icon: "icon ti-check-box",
    type: ["default"],
  },
  {
    path: "/User/Createnewitem",
    exact: true,
    component: CreateNewItem,
    name: "CreateNewItem",
    sub: "Request",
    label: "درخواست جدید",
    type: ["default"],
  },
  {
    path: "/User/Listnewitem",
    exact: true,
    component: ListNewItem,
    name: "listNewItem",
    sub: "Request",
    label: "لیست درخواست ها",
    type: ["default"],
  },
  {
    path: "/Time/Reserve/:inint",
    exact: true,
    component: TimeReservesList,
    name: "TimeReservesList",
    sub: "0",
    type: ["default"],
    label: "رزرو های تایم",
  },
  {
    path: "/User/setting",
    sub: "",
    component: Settings,
    name: "Setting",
    label: "تنظیمات پروفایل",
    icon: "icon ti-id-badge",
    type: ["default"],
  },

  {
    path: "/User/ClassList",
    component: ClassList,
    name: "ClassList",
    label: "لیست کلاسها",
    sub: "",
    icon: "icon ti-view-list-alt",
    exact: true,
    type: ["classmanager"],
  },
  {
    component: ClassCreate,
    name: "ClassList",
    label: "ایجاد کلاس",
    path: "/User/ClassCreate",
    sub: "",
    icon: "icon ti-view-list-alt",
    type: ["classmanager"],
    exact: true,
  },
  {
    component: SingleClass,
    name: "ClassInfoEdit",
    label: "ویرایش اطلاعات کلاس",
    path: "/User/ClassList/SingleClass",
    exact: true,
    type: ["classmanager"],
    icon: "icon ti-home",
  },
  {
    component: TagSeo,
    name: "TagSeo",
    label: "ویرایش تگ ها و سئو",
    path: "/User/ClassList/TagSeo",
    exact: true,
    type: ["classmanager"],
    icon: "icon ti-home",
  },
  {
    component: TeachersEdit,
    name: "TeachersEdit",
    label: "ویرایش مدرسین",
    path: "/User/ClassList/TeachersEdit",
    exact: true,
    type: ["classmanager"],
    icon: "icon ti-home",
  },
  {
    component: TimeEdit,
    name: "TimeEdit",
    label: "ویرایش مدرسین",
    path: "/User/ClassList/TimeEdit",
    exact: true,
    type: ["classmanager"],
    icon: "icon ti-home",
  },
  {
    component: AddTeacher,
    name: "AddTeacher",
    label: "ایجاد مدرس جدید",
    path: "/User/ClassList/AddTeacher",
    exact: true,
    type: ["classmanager"],
    icon: "icon ti-home",
  },
  {
    component: OrderDetails,
    name: "AddTeacher",
    label: "جزییات سفارش",
    path: "/User/OrderDetails/:trackingcodeorder",
    exact: true,
    type: ["default"],
    icon: "icon ti-home",
  },
  {
    component: PAList,
    name: "PAList",
    label: "لیست حضور",
    path: "/User/PAList/:reserve_id",
    exact: true,
    type: ["manager"],
    time: "needsession",
    icon: "icon ti-home",
  },
  {
    path: "/User/AthletesListOfClass",
    component: AthletesListOfClass,
    name: "AthletesListOfClass",
    label: "لیست ورزشکاران هر کلاس",
    path: "/User/AthletesListOfClass",
    exact: true,
    type: ["classmanager"],
    icon: "icon ti-home",
  },

  {
    path: "/User/ManageTimeTable",
    sub: "EditItem",
    component: ManageTimeTable,
    name: " ManageTimeTableBymanager",
    label: "مدیریت زمانبندی",
    type: ["manager"],
    icon: "",
  },

  {
    path: "/User/CommentManager",
    sub: "EditItem",
    component: CommentManagementManager,
    name: "CommentManagement",
    label: " کامنت ها",
    type: ["manager"],
    icon: "icon ti-comments",
  },

  {
    path: "/User/RequsetWallet/Create",
    exact: true,
    component: RequsetWalletCreate,
    name: "CreateTicket",
    sub: "RequestWallet",
    type: ["manager", "classmanager"],
    label: "ثبت درخواست برداشت",
  },
  {
    path: "/User/RequsetWallet/List",
    exact: true,
    component: RequsetWalletList,
    name: "ListTicket",
    sub: "RequestWallet",
    type: ["manager", "classmanager"],
    label: "لیست برداشت ها",
  },
  {
    path: "/User/finantial",
    sub: "RequestWallet",
    exact: true,
    component: ManFinantialDetails,
    name: "BookMark",
    label: "ویرایش اطلاعات مالی",
    type: ["manager", "classmanager"],
    icon: "icon ti-heart",
  },
  {
    path: "/User/GeneralOrders",
    sub: "Bill",
    exact: true,
    component: GeneralOrders,
    name: "BookMark",
    label: "صورت حساب کلی",
    type: ["manager", "classmanager"],
    icon: "icon ti-heart",
  },
  {
    path: "/User/ManagerReserves",
    sub: "Bill",
    exact: true,
    component: ManagerListReserves,
    name: "Reserves",
    label: <span>صورت حساب ها<br />  (لیست سفارشات) </span>,
    type: ["manager", "classmanager"],
    icon: "icon ti-control-shuffle",
  },
  // {
  //   path: "/User/ManagerReserves",
  //   sub: "Bill",
  //   exact: true,
  //   component: ManagerListReserves,
  //   name: "Reserves",
  //   label: "صورت حساب های پرداخت شده",
  //   type: ["manager", "classmanager"],
  //   icon: "icon ti-control-shuffle",
  // },
  {
    component: RenewalTermContract,
    name: "AddTeacher",
    label: "تمدید قراداد",
    path: "/User/renewaltermcontract/:trackingcodeorder",
    exact: true,
    type: ["default"],
    icon: "icon ti-home",
  },
];
